<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left>
        <a class="link color-theme-white popup-close" href="#">
          <i class="icon icon-back"></i>
          <span>返回</span>
        </a>
      </f7-nav-left>
      <f7-nav-title>{{ title }}</f7-nav-title>
    </f7-navbar>
    <div
      class="has-content"
      style="text-align: center;"
      v-if="data.length === 0">
      暂无数据
    </div>
    <f7-list v-else>
      <f7-list-item
        checkbox
        v-for="item in data"
        :title="item.name"
        :value="item.code"
        :key="item.code"
        :checked="result.indexOf(item.code) >= 0"
        @change="checkedItem">
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>
<script>
export default {
  name: 'PopupSelect',
  props: ['title', 'data', 'result'],
  data() {
    return {
      checkedList: this.result || [],
    };
  },
  methods: {
    checkedItem(event) {
      const value = event.target.value;
      if (event.target.checked) {
        this.checkedList.push(value);
      } else {
        this.checkedList.splice(this.checkedList.indexOf(value), 1);
      }
      this.$emit('update:result', this.checkedList);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PopupSelect.vue